// Entry point for the build script in your package.json
import "./popper.min.js"
import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"

import "bootstrap"
import { Tooltip, Popover } from 'bootstrap';
import "@hotwired/turbo-rails"
import "./controllers"
import "./react/src/index.js"
import "./add_jquery"

import $ from "jquery"
import "jquery-ui"
import "datatables.net-dt"
import "d3"
// import "./registration_wells"
import "./initialize_filepond"
import "./weather"

//import "./stylesheets/application.scss"

import { Grid } from "gridjs";
import "gridjs/dist/theme/mermaid.css";

import "./submissions"
import "./loading"
import "./calf_mortality_prediction"
import "./wean_weight_prediction"
// import "./channels/progress_consumer"

import {renderSoilGreatGroupTaxonomyMap} from "./maps/index"
import {initDataHubQuery} from "./data_hub/index"
window.luxon = require('luxon');

import { showLoading } from "./loading"


Rails.start()
Turbolinks.start()
ActiveStorage.start()

window.jQuery = $;
window.$ = $;
window.showLoading = showLoading;
// console.log("Hello from app/javascript/application.js")
// subscribeToProgressChannel()

document.addEventListener("turbolinks:load", () => {
    if (document.getElementById("dash-main-herd")) {
        import("./dashboard").then(({ initDashboard }) => initDashboard());
    }
});


document.addEventListener("turbo:load", function() {
    console.log("Hello from app/javascript/submission_show.js")
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl), {
        html: true,
    })
    console.log("Tooltips:", tooltipList)

    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
    const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new Popover(popoverTriggerEl, {
        html: true,
        sanitize: false,
    }))
    console.log("Popovers:", popoverList)

    const pathName = window.location.pathname
    const segments = pathName.split("/").filter(segment => segment !== "");
    const analyteID = segments[segments.length - 1]
    $('tr[id^="analyte-selection-row-"]').each(function() {
        if ($(this).attr('id') === `analyte-selection-row-${analyteID}`) {
            $(this).addClass('table-primary');  // color the selected analyte
            const timer = setTimeout(() => {
                document.getElementById($(this).attr('id')).scrollIntoView({block: "center", inline: "center"});
            }, 500)
        };
    });
})


// import '../../node_modules/gridstack/dist/gridstack.css';
// import '../../node_modules/gridstack/dist/gridstack-extra.css';
// import { GridStack } from 'gridstack';


// document.addEventListener("turbo:load", function() {
//     console.log("Hello from app/javascript/kit_grid.js")
//     // var options = {
//     //     cellHeight: 80,
//     //     verticalMargin: 10
//     // };
//     // var grid = GridStack.init(options);
//     // grid.addWidget('<div class="grid-stack-item"><div class="grid-stack" style="background-color: #ffa500;">Double Blank</div></div>', 0, 0, 1, 1, true);
//     // grid.addWidget('<div class="grid-stack-item"><div class="grid-stack" style="background-color: #8a2be2;">Blank</div></div>', 1, 0, 2, 1, true);

//     let options = {
//         float: false,
//         cellHeight: 99,

//     }
//     GridStack.init(options);


// })



// document.addEventListener("DOMContentLoaded", function() {
//     const form = document.getElementById('new_analyte_entries_form');
//     form.addEventListener('ajax:success', function(event) {
//       const [data, status, xhr] = event.detail;
//       // Handle the JSON response here
//       console.log(data); // Example: log the response
//     });
// });

document.addEventListener("turbo:load", () => {
    const el = document.getElementById("soil-map");
    if (!el) return;

    renderSoilGreatGroupTaxonomyMap(el, {
        // Example: Alberta-ish
        // center: [53.5, -113.5],
        // zoom: 6,
        // opacity: 0.7,
    });
});

document.addEventListener("turbo:load", () => {
    initDataHubQuery();
});
